import React, { useEffect, useRef, useState } from 'react';
import moment from 'moment';
import "../CountdownComponent/capp.css";
import CountDownCard from './CountDownCard';

/*const CountDownTimwe extends React.Component {
  //card ref
  const SecondsCardRef = useRef(null);
  const MinutesCardRef = useRef(null);
  const HoursCardRef = useRef(null);
  const DaysCardRef = useRef(null);


  //state
  const [days, setDays] = useState(undefined);
  const [hours, setHours] = useState(undefined);
  const [minutes, setMinutes] = useState(undefined);
  const [seconds, setSeconds] = useState(undefined);

  useEffect(() => {
    seconds === 0 && setSeconds(59);
    minutes === 0 && setMinutes(59);
    if (seconds > 0) {
      setTimeout(() => {
        setSeconds(seconds - 1);
        SecondsCardRef.current.classList.toggle('rotate');
      }, 1000);
    }
    if (seconds === 0 && minutes > 0) {
      setMinutes(minutes - 1);
      MinutesCardRef.current.classList.toggle('rotate');
    }
  }, [seconds, minutes]);
  useEffect(() => {
    hours === 0 && setHours(23);
    if (minutes === 0 && hours > 0) {
      setHours(hours - 1);
      HoursCardRef.current.classList.toggle('rotate');
    }
  }, [minutes, hours]);
  useEffect(() => {
    days === 14 && setDays(13);
    hours === 0 &&
      setDays(days - 1) &&
      DaysCardRef.current.classList.toggle('rotate');
  }, [hours, days]);

  */

  class CountDownTimer extends React.Component {


    state = {
        days: undefined,
        hours: undefined,
        minutes: undefined,
        seconds: undefined,
    };

    componentDidMount() {
        this.interval = setInterval(() => {
            const { timeTillDate, timeFormat } = this.props;
            const then = moment(timeTillDate, timeFormat);
            const now = moment();
            const countdown = moment(then - now);
            const days = countdown.format('D');
            const hours = countdown.format('HH');
            const minutes = countdown.format('mm');
            const seconds = countdown.format('ss');
            this.setState({ days, hours, minutes, seconds });
        }, 1000);
    }

    componentWillUnmount() {
        if (this.interval) {
            clearInterval(this.interval);
        }
    }

    render() {
        const { days, hours, minutes, seconds } = this.state;

        const DaysCardRef = false;
        const HoursCardRef = false;
        const MinutesCardRef = 0;
        const SecondsCardRef = 0;
    
  return (
    <div className="countdown__container">
      <CountDownCard
        label="days"
        number={days}
        //cardRef={DaysCardRef}
      />
      <CountDownCard
        label="hours"
        number={hours}
        //cardRef={HoursCardRef}
      />
      <CountDownCard
        label="minutes"
        number={minutes}
        //cardRef={MinutesCardRef}
      />
      <CountDownCard
        label="seconds"
        number={seconds}
        //cardRef={SecondsCardRef}
      />
    </div>
  );
  }
};

export default CountDownTimer;